// extracted by mini-css-extract-plugin
module.exports = {"banner_button":"modalconfirm_banner_button__25yag","content":"modalconfirm_content__f7TLJ","subtitle_popup":"modalconfirm_subtitle_popup__FH2wS"};